export default "__VITE_ASSET__DWwkyCsX__"